import { useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';

type UseNavigationStateListenerParams = {
  onParkingZoneChange?: (parkingZoneUid: string) => void;
};

export const useNavigationStateListener = ({
  onParkingZoneChange,
}: UseNavigationStateListenerParams = {}) => {
  const navigation = useNavigation();

  useEffect(() => {
    const unsubscribe = navigation.addListener('state', (e) => {
      const routeStack = e?.data?.state?.routes[e.data.state.index];
      const currentRouteParams = routeStack?.state?.routes[
        routeStack?.state?.index ?? 0
      ]?.params as { parkingZoneUid: string | undefined } | undefined;

      if (currentRouteParams?.parkingZoneUid && onParkingZoneChange) {
        onParkingZoneChange(currentRouteParams.parkingZoneUid);
      }
    });

    return unsubscribe;
  }, [navigation, onParkingZoneChange]);
};
